import  './../css/Gtop.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {systemConfiguration} from "../../CommonImports";
import Offcanvas from "bootstrap/js/dist/offcanvas";
import GJobSingle from './GJobSingle';


function GHeader() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
     const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';


     const toggleSidebar = () => {
      const el = document.getElementById("rightSidebar");
      if (!el) return;

      const instance = Offcanvas.getOrCreateInstance(el);

      if (el.classList.contains("show")) {
        instance.hide();
      } else {
        instance.show();
      }
    };
     
return (
    <div>
    <header className="header">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center" style={{height:"120px"}}>
        
          <div className="header-logo">
            <a href="#"><img src={mediaUrl+"GJobHuubLogo.jpg?"+sasToken} alt="jobhub"/></a>
          </div>

          
          <nav className="nav-main-menu d-none d-xl-block mx-auto">
            <ul className="main-menu">
              <li>
                <a href="#">Home</a>
                <ul className="sub-menu">
                  <li><a href="/GHomePage1">Home 1</a></li>
                  <li><a href="#">Home 2</a></li>
                  <li><a href="#">Home 3</a></li>
                </ul>
              </li>
              <li>
                <a href="#">Browse Jobs</a>
                <ul className="sub-menu">
                  <li><a href="/">Job Grid</a></li>
                  <li><a href="#">Job Grid 2</a></li>
                  <li><a href="#">Job List</a></li>
                  <li><hr/></li>
                  <li><a href="/GJobSingle">Job Single</a></li>
                  <li><a href="#">Job Single 02</a></li>
                  <li><a href="#">Job Single 03</a></li>
                </ul>
              </li>
              <li>
                <a href="#">Employers</a>
                <ul className="sub-menu">
                  <li><a href="/">Employers Grid</a></li>
                  <li><a href="#">Employers Grid 2</a></li>
                  <li><a href="#">Employers List</a></li>
                  <li><hr/></li>
                  <li><a href="/GEmployersSingle">Employers Single 01</a></li>
                  <li><a href="#">Employers Single 02</a></li>
                </ul>
              </li>
              <li>
                <a href="#">Candidates</a>
                <ul className="sub-menu">
                  <li><a href="/GCandidatesgrid">Candidates Grid</a></li>
                  <li><a href="#">Candidates Grid 2</a></li>
                  <li><a href="#">Candidates List</a></li>
                  <li><hr/></li>
                  <li><a href="/GCandidateSingle">Candidates Single 01</a></li>
                  <li><a href="/GCandidateSingle">Candidates Single 02</a></li>
                </ul>
              </li>
              <li>
                <a href="#">Pages</a>
                <ul className="sub-menu">
                  <li><a href="/GJobAboutUs">About Us</a></li>
                  <li><a href="/GServices">Our Services</a></li>
                  <li><a href="#">Pricing Plan</a></li>
                  <li><a href="#">FAQs</a></li>
                  <li><a href="/GJobContactUs">Contact Us</a></li>
                </ul>
              </li>
            </ul>
          </nav>

        
          <button className="btn btn-primary mobile-toggle" type="button" onClick={toggleSidebar}>
            ☰
          </button>
        </div>
      </div>
    </header>

    </div>
)

}
export default GHeader;